import {
	UPDATE_REFERRER_SETTINGS,
	UPDATE_REFERRER_SETTINGS_SUCCESS,
	UPDATE_REFERRER_SETTINGS_ERROR,
	FETCH_REFERRER_SETTINGS,
	FETCH_REFERRER_SETTINGS_SUCCESS,
	FETCH_REFERRER_SETTINGS_ERROR,
	RESET_REFERRER_SETTINGS_SAVED,
} from './constants';

export const updateSettings = (settings) => ({ type: UPDATE_REFERRER_SETTINGS, settings });
export const updateSettingsSuccess = (data) => ({ type: UPDATE_REFERRER_SETTINGS_SUCCESS, data });
export const updateSettingsError = (error) => ({ type: UPDATE_REFERRER_SETTINGS_ERROR, error });

export const fetchSettings = () => ({ type: FETCH_REFERRER_SETTINGS });
export const fetchSettingsSuccess = (data) => ({ type: FETCH_REFERRER_SETTINGS_SUCCESS, data });
export const fetchSettingsError = (error) => ({ type: FETCH_REFERRER_SETTINGS_ERROR, error });

export const resetSaved = () => ({ type: RESET_REFERRER_SETTINGS_SAVED });
